import React, { useState, useEffect } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import Spinner from '../../utils/Spinner';
import MonitorUrlCrudService from '../../../services/MonitorUrlCrudService';

export default function ModalSyncUrls({ show, handleClose }) {

  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  useEffect(() => {
    if (show) {
      handleSync();
    } else {
      setSuccessMessage(null);
      setIsLoading(false);
    }
  }, [show]);

  const handleSync = async () => {
    setIsLoading(true);
    MonitorUrlCrudService.syncUrls().then(res => {
      console.log(res);
      sleep(1500).then(() => {
        setSuccessMessage('success');
        setIsLoading(false);
      })
    }).catch(err => {
      console.error('Error trying Sync URLs: ', err);
      setIsLoading(false);
      setSuccessMessage('danger');
    });
  };

  return (
    <>
      <Modal size="sm" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> Sincronizando Urls </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? <Spinner /> : null}
          <hr></hr>
          {successMessage === 'danger' && (
            <Alert key="danger" variant="danger">
              Error al Sincronizar!<br/>Intenta más tarde!
            </Alert>
          )}
          {successMessage === 'success' && (
            <Alert key="success" variant="success">
              URLs Sincronizadas!
            </Alert>
          )}
          <hr></hr>
          <Button variant="secondary" onClick={handleClose}> Close </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}